import { ApiClient } from './client';

export interface SavedVocabularyItem {
  id: string;
  userId: string;
  word: string;
  partOfSpeech?: string | null;
  definition: string;
  example: string;
  wordAudioUrl?: string | null;
  savedAt: number; // Unix ms
}

export type SavedVocabularyItemInput = Omit<SavedVocabularyItem, 'id' | 'userId' | 'savedAt'>;

export function getSavedVocabulary(): Promise<SavedVocabularyItem[]> {
  return ApiClient.get<SavedVocabularyItem[]>('/users/me/vocabulary');
}

export function saveVocabularyItem(item: SavedVocabularyItemInput): Promise<SavedVocabularyItem> {
  return ApiClient.post<SavedVocabularyItem>('/users/me/vocabulary', item);
}

export function deleteVocabularyItem(word: string): Promise<{ success: boolean }> {
  return ApiClient.delete<{ success: boolean }>(`/users/me/vocabulary/${encodeURIComponent(word)}`);
}
